import Vue from 'vue'
import env from '../services/environment'

let apiPath = 'https://' + env.apiTargetPath + env.apiPrefix

export default {
  getSiteCameras: function (siteId) {
    let apiDetailPath = '/sites/' + siteId + '/devices/cameras'
    return Vue.http.get(apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getSiteCamera: function (siteId, cameraId) {
    let apiDetailPath = '/sites/' + siteId + '/devices/' + cameraId
    return Vue.http.get(apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getLiveSnapshot: function (siteId, deviceId) {
    let apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/snapshot'
    return Vue.http.get(apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getSiteCameraEvent: function (siteId, deviceId, eventId) {
    let apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/events/' + eventId
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  createThumbnailVideo: function (siteId, deviceId, year, month, day) {
    let apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/thumbnailvideos/years/' + year + '/months/' + month + '/days/' + day
    return Vue.http.post(apiPath + apiDetailPath, {}, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getThumbnailVideo: function (siteId, deviceId, thumbnailVideoId) {
    let apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/thumbnailvideos/' + thumbnailVideoId + '/perdays'
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getThumbnailVideos: function (siteId, deviceId, stime, etime) {
    let apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/thumbnailvideos/stime/' + stime + '/etime/' + etime + '/perdays'
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  }
  // updateFactoryMac: function () {
  //   let apiDetailPath = '/admin/factory/macs'
  //   Vue.http.post(apiPath + apiDetailPath, {mac: 'B827EB5236E7', entry_key: 'B591C0', model: 'CKB304'}, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  //   Vue.http.post(apiPath + apiDetailPath, {mac: 'B827EB843A52', entry_key: '22C2C0', model: 'CKB304'}, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  // }
}



// WEBPACK FOOTER //
// ./src/api/device.js